export default __webpack_public_path__ + "static/media/david.483d0aa9.png";